import React, {Component} from 'react';
import {Redirect, Route, BrowserRouter as Router, Switch} from 'react-router-dom';
import './index.css';

import {LanguageContext} from './LanguageContext';
import Complete from './components/Complete';
import CompleteGreenQuarter from './components/CompleteGreenQuarter';
import CompleteGreenQuarterManager from './components/CompleteGreenQuarterManager';
import Home from './components/Home';
import ManagerSubmission from './components/ManagerSubmission';
import Site from './components/Site';
import SouthallSites from './components/SouthallSites';
import SouthallSitesManager from './components/SouthallSitesManager';
import Submission from './components/Submission';
import SubmissionWithoutPhase from './components/SubmissionWithoutPhase';

// ie support
import 'core-js/es6/number';
import 'core-js/es6/reflect';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/array/includes';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lang: {
        options: ['EN', 'RO'],
        selected: 'EN',
      },
    };
  }

  changeLanguage = (language) => {
    this.setState({
      lang: {
        selected: language,
      },
    });
  };

  render() {
    return (
      <LanguageContext.Provider value={{changeLanguage: this.changeLanguage, lang: this.state.lang}}>
        <Router>
          <div className="max-w-md m-auto md:h-screen">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/site" component={Site} />
              <Route exact path="/green-quarter" component={SouthallSites} />
              <Route exact path="/green-quarter-intervention" component={SouthallSitesManager} />
              <Route exact path="/southall">
                <Redirect to="/green-quarter" />
              </Route>
              <Route
                exact
                path="/submission/:siteName"
                render={({match}) => {
                  return [
                    'kidbrooke',
                    'poplar',
                    'alexandraGate',
                    'southall',
                    'royalArsenal',
                    'greenQuarter',
                    'snowhillWharf',
                    'eastbrook',
                    'highcroft',
                    'swansLanding',
                    'glasswaterLocks',
                    'plumsteadWestThamesmead',
                    'hertfordLocks',
                    'suttonGardenSquare',
                  ].includes(match.params.siteName) ? (
                    <Submission siteName={match.params.siteName} />
                  ) : [
                      'londonDock',
                      'royalExchange',
                      'chelseaCreek',
                      'fulhamReach',
                      'wandsworthMills',
                      'grandUnion',
                      'beaufortPark',
                      'silkStream',
                      'camdenGoodsYard',
                    ].includes(match.params.siteName) ? (
                    <SubmissionWithoutPhase siteName={match.params.siteName} />
                  ) : (
                    <Redirect to="/site" />
                  );
                }}
              />
              <Route
                exact
                path="/submission/:siteName/manager-intervention"
                render={({match}) => {
                  return ['kidbrooke', 'southall', 'royalArsenal', 'swansLanding'].includes(match.params.siteName) ? (
                    <ManagerSubmission siteName={match.params.siteName} />
                  ) : [
                      'wandsworthMills',
                      'glasswaterLocks',
                      'greenQuarter',
                      'snowhillWharf',
                      'eastbrook',
                      'highcroft',
                      'londonDock',
                      'royalExchange',
                      'chelseaCreek',
                      'fulhamReach',
                      'grandUnion',
                      'beaufortPark',
                      'silkStream',
                      'camdenGoodsYard',
                      'hertfordLocks',
                      'suttonGardenSquare',
                    ].includes(match.params.siteName) ? (
                    <Redirect to="/site" />
                  ) : (
                    <Redirect to="/site" />
                  );
                }}
              />
              <Route exact path="/complete" component={Complete} />
              <Route exact path="/complete-green-quarter" component={CompleteGreenQuarter} />
              <Route exact path="/complete-green-quarter-manager" component={CompleteGreenQuarterManager} />
              <Redirect exact from="/submission/" to="/site" />
            </Switch>
          </div>
        </Router>
      </LanguageContext.Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js